var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18837 0H21.2289L31.4277 10.6402V31.3116C31.4277 33.8994 29.327 36 26.7393 36H9.18837C6.60063 36 4.5 33.8994 4.5 31.3116V4.68837C4.5 2.10063 6.60063 0 9.18837 0Z",
    fill: "#FA0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2146 0V10.5488H31.4286L21.2146 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.198 19.2707C24.0763 19.1793 23.8936 19.1793 23.7566 19.2402L20.7274 20.7624V19.6664C20.7274 18.8901 20.1186 18.2812 19.3422 18.2812H12.8881C12.127 18.2812 11.5029 18.8901 11.5029 19.6664V25.192C11.5029 25.9683 12.127 26.5772 12.8881 26.5772H19.3422C20.1186 26.5772 20.7274 25.9683 20.7274 25.192V24.096L23.7566 25.6182C23.9849 25.7248 24.259 25.6335 24.3807 25.4051C24.4111 25.3442 24.4264 25.2681 24.4264 25.192V19.6664C24.4264 19.499 24.3351 19.3468 24.198 19.2707ZM16.1152 24.2787C15.0953 24.2787 14.2733 23.4414 14.2733 22.4216C14.2733 21.4017 15.0953 20.5797 16.1152 20.5797C17.1351 20.5797 17.9571 21.4017 17.9571 22.4216C17.9571 23.4414 17.1351 24.2787 16.1152 24.2787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.01032a84ea9bcb17e6355bef4e195ddf.svg";
export { ForwardRef as ReactComponent };